export function applyTheme(theme: "light" | "dark") {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);

    // custom event tetikle
    window.dispatchEvent(new CustomEvent("theme-changed", { detail: theme }));
}

export const toggleTheme = (callback?: (newTheme: string) => void) => {
    const current = localStorage.getItem("theme") || "light";
    const newTheme = current === "dark" ? "light" : "dark";
    applyTheme(newTheme); // hem localStorage hem data-theme hem event

    if (callback) callback(newTheme);
};

export function initTheme() {
    const savedTheme = localStorage.getItem("theme") as "light" | "dark" | null;
    if (savedTheme) {
        applyTheme(savedTheme);
    } else {
        applyTheme("light");
    }
}